<template>
  <li class="pagination_list-item">
    <component
      :is="show_link_tag ? 'a' : 'span'"
      @click.prevent="emitClick"
      v-html="text"
      v-bind="link_data">
    </component>
  </li>
</template>

<script>

export default {
  name: "PaginationItem",
  props: {
    href: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    show_link_tag() {
      return Boolean(this.href)
    },
    link_data() {
      if (!this.show_link_tag) return null
      return {
        href: this.href
      }
    }
  },
  methods: {
    emitClick(e) {
      if (!this.show_link_tag) return
      this.$emit('click', e)
    }
  }
}
</script>
